import styles from './IconDefault.module.scss';

export function IconFlask() {
	return (
		<svg
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={styles.mediumIllustration}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.34182 31.9844L11.75 26.125H31.0625L36.0147 31.9844C38.3964 35.0846 36.1862 39.5697 32.2768 39.5697H11.0797C7.17029 39.5697 4.9601 35.0846 7.34182 31.9844ZM25 29C23.3431 29 22 30.3431 22 32C22 33.6569 23.3431 35 25 35C26.6569 35 28 33.6569 28 32C28 30.3431 26.6569 29 25 29Z"
				fill="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
			/>
			<path
				d="M14.193 18.826a1 1 0 0 0 1.586 1.219l-1.586-1.219ZM5.664 30.268l-.758-.652-.018.02-.017.023.793.609Zm28.673 0 .793-.61-.017-.021-.018-.021-.758.652Zm-9.322-10.832-.793.609.017.022.018.021.758-.652ZM13.03 9.063l.197-.98a1 1 0 0 0-.484 1.937l.287-.957Zm14.058 0 .288.957a1 1 0 0 0-.478-1.94l.19.982ZM20 10.313l.005-1-.005 1ZM9.516 27.325A1 1 0 0 0 8 26.021l1.516 1.304Zm6.77-11.718h1V11.141h-2V15.607h1Zm-.507 4.438a7.285 7.285 0 0 0 1.508-4.438h-2a5.285 5.285 0 0 1-1.094 3.22l1.586 1.218ZM9.402 36.853c-3.08 0-4.821-3.533-2.945-5.976L4.871 29.66c-2.887 3.758-.208 9.194 4.531 9.194v-2Zm21.197 0H9.402v2h21.197v-2Zm2.945-5.976c1.876 2.443.135 5.976-2.945 5.976v2c4.739 0 7.418-5.437 4.531-9.194l-1.586 1.218Zm-9.287-10.789L33.58 30.92l1.516-1.304-9.322-10.833-1.516 1.305Zm-1.543-4.481c0 1.605.53 3.165 1.508 4.438l1.586-1.219a5.285 5.285 0 0 1-1.094-3.22h-2Zm-5.427-4.464c0-.77-.444-1.331-.858-1.686-.419-.36-.934-.622-1.383-.811a10.3 10.3 0 0 0-1.803-.56l-.01-.003h-.005l-.198.98-.197.98h-.001.004a4.6 4.6 0 0 1 .108.025 8.844 8.844 0 0 1 1.327.422c.365.153.664.32.856.485.197.17.16.225.16.168h2Zm9.801-2.08-.19-.982h-.006a1.786 1.786 0 0 0-.045.01l-.123.027a11.484 11.484 0 0 0-1.698.523c-.463.188-.992.449-1.422.805-.422.349-.89.912-.89 1.697h2c0 .071-.046.018.165-.157.202-.167.517-.337.898-.491a8.907 8.907 0 0 1 1.477-.446l.021-.004h.004v-.001l-.19-.982Zm-2.374 6.544v-4.464h-2v4.464h2ZM13.03 9.063l-.287.957h.002l.003.002.01.003.038.011a32.134 32.134 0 0 0 .664.186c.442.119 1.06.277 1.771.436 1.403.315 3.232.648 4.764.655l.01-2c-1.308-.006-2.964-.299-4.336-.606a41.44 41.44 0 0 1-2.35-.602h-.002l-.287.957Zm6.965 2.25c1.56.007 3.421-.327 4.848-.644a42.872 42.872 0 0 0 2.48-.633l.038-.011.01-.004h.004l-.287-.959-.288-.957H26.8l-.008.003a9.248 9.248 0 0 1-.164.047 40.78 40.78 0 0 1-2.218.561c-1.396.311-3.078.603-4.404.597l-.01 2ZM6.422 30.92l3.094-3.595L8 26.021l-3.094 3.595 1.516 1.304Z"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
			<circle
				cx="10.916"
				cy="24.457"
				r="1"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
			<circle
				cx="13"
				cy="22"
				r="1"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
			<path
				d="M26.0195 3.69336C26.0195 5.35021 24.6764 6.69336 23.0195 6.69336C21.3627 6.69336 20.0195 5.35021 20.0195 3.69336C20.0195 2.03651 21.3627 0.693359 23.0195 0.693359C24.6764 0.693359 26.0195 2.03651 26.0195 3.69336Z"
				fill="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
			/>
			<path
				d="M17 5.19336C17 6.02179 16.3284 6.69336 15.5 6.69336C14.6716 6.69336 14 6.02179 14 5.19336C14 4.36493 14.6716 3.69336 15.5 3.69336C16.3284 3.69336 17 4.36493 17 5.19336Z"
				fill="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
			/>
			<path
				d="M23.5004 29.4015C22.0655 30.2299 21.5739 32.0647 22.4023 33.4996C23.2308 34.9345 25.0655 35.4261 26.5004 34.5977C27.9353 33.7692 28.4269 31.9345 27.5985 30.4996"
				stroke="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
				strokeWidth="2"
				strokeLinecap="round"
			/>
		</svg>
	);
}
